import requestResult from '@/common/request/request'
import { User as _User } from '@/modules/user/user.api'

export type User = _User

export const fbLogin = requestResult<User>('/api/user/fb/login')

export const bindFB = requestResult<User>('/api/user/bind/fb')
